import React, { useEffect, useState } from 'react'
import ProductsBanner from '../components/ProductsBanner'
import MonthTable from './components/MonthTable';

function AgricultureDate() {
  const [activeIndex, setActiveIndex] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  
  const faqs = [
    {
      question: " كيفية تهيئة التربة ",
      answer: [
        "•	تحليل التربة: قبل البدء في الزراعة، يجب إجراء تحليل للتربة لتحديد محتوى العناصر الغذائية ومستوى الحموضة (pH)، حتى يتمكن المزارع من إضافة الأسمدة المناسبة.",
        "•	تنظيف الأرض: إزالة الأعشاب الضارة، الحجارة، وأي مواد غير مرغوب فيها من الأرض قبل الزراعة.",
        "•	التقليب والتسوية: تقليب التربة باستخدام المحراث أو الآلات الزراعية لتفتيت الكتل الكبيرة وتحسين تهوية التربة. ثم يتم تسويتها لضمان توزيع متساوٍ للبذور أو الشتلات.",
        "•	إضافة المواد العضوية: يمكن إضافة السماد العضوي لتحسين خصوبة التربة وزيادة قدرتها على الاحتفاظ بالماء.",
        "•	تحسين الصرف: في المناطق ذات التربة الثقيلة أو الطينية، يمكن تحسين الصرف بإضافة الرمل أو المواد العضوية لزيادة المسامية.",
      ],
    },
    {
      question: "كيفية زراعة الخضر ",
      answer: [
        "•	اختيار المحصول المناسب: اختيار أنواع الخضر التي تتناسب مع المناخ المحلي ونوع التربة",
        "•	الزراعة في التوقيت المناسب: يجب زراعة الخضر في فصول السنة المناسبة لتجنب التأثيرات المناخية السيئة مثل الصقيع أو الحرارة الشديدة. ",
        "•	المسافات بين النباتات: يجب تحديد المسافات بين النباتات بناءً على حجمها عند النضج. المسافات المتقاربة قد تؤدي إلى التنافس على الغذاء والضوء.",
        "•	الري: الحفاظ على توازن في الري حسب احتياجات كل محصول. الخضر عادةً تحتاج إلى ري منتظم ولكن دون غمر التربة بالماء.",
      ],
    },
    {
      question: "كيفية زراعة الفاكهة",
      answer: [
        "•	اختيار الأنواع المناسبة: تحديد أنواع الفاكهة المناسبة للمنطقة مثل المانجو، البرتقال، العنب، والتفاح. يجب مراعاة عوامل مثل درجة الحرارة، الأمطار، والظروف المناخية.",
        "•	التربة المناسبة: تفضّل محاصيل الفاكهة التربة جيدة الصرف، حيث يجب أن تكون التربة ذات قدرة على الاحتفاظ بالماء ولكن مع تصريف جيد للمياه الزائدة.",
        "•	الري: الأشجار تحتاج إلى ري دوري وخاصة في فصل الصيف، ولكن يجب تجنب الري الزائد لأن ذلك قد يؤدي إلى تعفن الجذور.",
        "•	التقليم والعناية: تأكد من تقليم الأشجار بانتظام لتحفيز نمو جديد وتحسين إنتاجية المحصول. أيضاً، يجب العناية بمكافحة الآفات والأمراض بشكل دوري.",
      ],
    },
    {
      question: "الأسمدة والمغذيات",
      answer: [
        "•	الأسمدة العضوية والكيميائية: بناءً على تحليل التربة، يمكن استخدام الأسمدة العضوية لتحسين خصوبة التربة. الأسمدة الكيميائية تساعد في تزويد النباتات بالعناصر الغذائية مثل النيتروجين، الفوسفور، والبوتاسيوم.",
        "•	التسميد المتوازن: يجب أن يتم التسميد بناءً على احتياجات المحاصيل المحددة وتوقيت النمو. على سبيل المثال، في فترة النمو الخضري، قد يحتاج النبات إلى كميات كبيرة من النيتروجين.",
      ],
    },
    {
      question: "كيفية مكافحة الآفات والأمراض",
      answer: [
        "•	مراقبة الصحة النباتية: من المهم فحص المحاصيل بشكل دوري للتأكد من عدم وجود علامات للآفات أو الأمراض. يمكن استخدام المبيدات ( حشرية – عناكب -  فطرية – أعشاب – نيماتودا – بكتريا – قوارض ورخويات ) ",
      ],
    },
    {
      question: "كيفية مراقبة النمو",
      answer: [
        "•	التغذية والري: تأكد من مراقبة نمو المحاصيل بشكل دوري، وتعديل جداول الري والتسميد حسب الحاجة. كما يجب متابعة تطور المحصول لضمان الحصول على أفضل إنتاجية.",
      ],
    },
    {
      question: "كيفية الحصاد والتخزين",
      answer: [
        "•	وقت الحصاد: الحصاد في الوقت المناسب لضمان جودة المحصول. الخضروات والفواكه يجب أن تُجمع عندما تصل إلى مرحلة النضج المثلى.",
        "•	التخزين: يجب تخزين المحاصيل في أماكن باردة وجافة، خاصة الفواكه التي قد تحتاج إلى معالجة مثل التبريد أو التعبئة للحفاظ على جودتها لفترة أطول.",
      ],
    },
    {
      question: "الخلاصة",
      answer: [
        "الزراعة الناجحة تعتمد على تهيئة التربة بشكل جيد، اختيار المحاصيل المناسبة، ومراقبة الري والتسميد، بالإضافة إلى اتباع استراتيجيات فعّالة لمكافحة الآفات. من خلال الانتباه لهذه العوامل، يمكن تحسين الإنتاجية والحصول على محاصيل صحية وجيدة الجودة."
      ],
    },
    {
      question: "جدول بالمواعيد المناسبة لزراعة المحاصيل والخضر",
      answer: [
        "الزراعة الناجحة تعتمد على تهيئة التربة بشكل جيد، اختيار المحاصيل المناسبة، ومراقبة الري والتسميد، بالإضافة إلى اتباع استراتيجيات فعّالة لمكافحة الآفات. من خلال الانتباه لهذه العوامل، يمكن تحسين الإنتاجية والحصول على محاصيل صحية وجيدة الجودة."
      ],
    },
  ];
  return (
    <>
<div className="fertilizer-banner">
      {/* الخلفية الخضراء مع الصورة */}
      <div className="banner-background"></div>

      {/* المحتوى */}
      <div className="banner-content">
        <h1 className="banner-title">إرشادات عامة للزراعة</h1>

        <div className="breadcrumb">
          <a href="/" className="breadcrumb-link">
            الرئيسية
          </a>
          <span className="breadcrumb-separator">
          <i className="fa-solid fa-caret-right"></i>
          </span>
          <span className="breadcrumb-current">إرشادات عامة للزراعة</span>
        </div>
      </div>
    </div>       
<section id="FAQ">
<div id="agridate">
  
    <h1 className="title">ارشادات عامة للزراعة</h1>
    <div className="container">
    <p className='agri-tabel'>جدول بالمواعيد المناسبة لزراعة المحاصيل والخضر</p>
    <MonthTable/>

      <div className="FAQ-box">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
          >
            <div className="faq-question" onClick={() => toggleFAQ(index)}>
              {faq.question}
              <span className="icon">{activeIndex === index ? "-" : "+"}</span>
            </div>
            <div
              className="faq-answer"
              style={{ display: activeIndex === index ? "block" : "none" }}
            >
              <ul className="FAQ-ul">
                {faq.answer.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
    </div>
  </section>
    </>
    
  )
}

export default AgricultureDate